module.exports = __webpack_public_path__ + "img/MES5Indice1_Sommaire.363d85e8.png";